import React from 'react';

//------ Home Icon ------//
export const HomeIcon = ({ width = '1.25vw' }) => (
    <svg width={width} viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group">
            <path id="Vector" d="M0 7V18H6V12H10V18H16V7L8 0L0 7Z" fill="black" stroke="white" />
        </g>
    </svg>
);

//------ Feedback Icon ------//
export const FeedbackIcon = ({ width = '1.25vw' }) => (
    <svg width={width} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="ooui:feedback-ltr">
            <path
                id="Vector"
                d="M19.9498 16.8L2.0998 12.6C1.44363 11.8809 1.07056 10.9483 1.0498 9.97502C1.07056 9.00178 1.44363 8.0691 2.0998 7.35002L19.9498 3.15002V16.8Z"
                fill="black"
                stroke="white"
            />
            <path
                id="Vector_2"
                d="M8.4002 11.55C8.4002 10.3902 7.45999 9.44995 6.3002 9.44995C5.1404 9.44995 4.2002 10.3902 4.2002 11.55V15.75C4.2002 16.9097 5.1404 17.85 6.3002 17.85C7.45999 17.85 8.4002 16.9097 8.4002 15.75V11.55Z"
                fill="black"
                stroke="white"
            />
        </g>
    </svg>
);

export default FeedbackIcon;

//------ History icon ------//
export const HistoryIcon = ({ width = '1.25vw' }) => (
    <svg width={width} viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            id="Vector"
            d="M7.01153 14.5235C8.19153 15.4535 9.68153 16.0035 11.2915 16.0035C15.1915 16.0035 18.3415 12.8135 18.2915 8.90349C18.2415 5.18349 15.1115 2.05349 11.3915 2.00349C7.64052 1.95565 4.56708 4.83785 4.30907 8.50349H4.29153V9.00349H4.79153H6.08153C6.18025 9.00291 6.27693 9.03156 6.35938 9.08584C6.44184 9.14012 6.50638 9.21759 6.54488 9.30849C6.58338 9.39938 6.59411 9.49965 6.57572 9.59663C6.55733 9.69362 6.51064 9.783 6.44153 9.85349L3.65153 12.6535M7.01153 14.5235C6.82 14.3726 6.57968 14.2974 6.3363 14.3121C6.09292 14.3269 5.86345 14.4306 5.69153 14.6035C5.27153 15.0235 5.30153 15.7335 5.77153 16.0935C7.34274 17.3358 9.28853 18.0091 11.2915 18.0035C16.3415 18.0035 20.4315 13.8335 20.2915 8.74349M7.01153 14.5235L6.70213 14.9163M7.01153 14.5235L6.70204 14.9162C6.70207 14.9162 6.7021 14.9162 6.70213 14.9163M20.2915 8.74349C20.1615 4.05349 16.2415 0.13349 11.5515 0.00349014M20.2915 8.74349L19.7917 8.75734C19.7917 8.75731 19.7917 8.75727 19.7917 8.75724M20.2915 8.74349L19.7917 8.75724M11.5515 0.00349014C6.46153 -0.13651 2.29153 3.95349 2.29153 9.00349H1.79153H0.501534C0.0515344 9.00349 -0.168466 9.54349 0.151534 9.85349L2.94153 12.6535M11.5515 0.00349014L11.5378 0.503301C15.9624 0.626004 19.669 4.3326 19.7917 8.75724M11.5515 0.00349014L11.5377 0.503298C6.73004 0.371123 2.79153 4.23416 2.79153 9.00349V9.50349H2.29153H0.508629L3.29509 12.2999L2.94153 12.6535M2.94153 12.6535C3.14153 12.8535 3.45153 12.8535 3.65153 12.6535M2.94153 12.6535L3.29572 12.3006L3.29523 12.3001C3.29569 12.3005 3.29613 12.301 3.29653 12.3013M3.65153 12.6535L3.29735 12.3006L3.29784 12.3001C3.29738 12.3005 3.29694 12.301 3.29653 12.3013M3.65153 12.6535L3.29798 12.2999L6.08445 9.50348M6.08445 9.50348H6.08447L6.44148 9.85343L6.09163 9.50484L6.08854 9.50176L6.08735 9.50057L6.08452 9.50341L6.08451 9.50342L6.08447 9.50346L6.08445 9.50348ZM6.08445 9.50348L6.08153 9.5035L4.29153 9.50349H3.79153V9.00349C3.79153 4.82487 7.19929 1.44998 11.3979 1.50353L11.3983 1.50354C15.3891 1.55718 18.7378 4.90589 18.7915 8.89677L18.7915 8.8971C18.8451 13.0853 15.4706 16.5035 11.2915 16.5035C9.56609 16.5035 7.96776 15.9137 6.70213 14.9163M6.70213 14.9163C6.60694 14.8413 6.4875 14.8039 6.36655 14.8112C6.24559 14.8186 6.13155 14.8701 6.04611 14.956L6.04509 14.957C5.82733 15.1748 5.85821 15.5301 6.07557 15.6966L6.08169 15.7012L6.08165 15.7013C7.56418 16.8735 9.40017 17.5088 11.2901 17.5035L11.2915 17.5035C16.0609 17.5035 19.924 13.5649 19.7917 8.75724M3.29653 12.3013C3.29356 12.304 3.29221 12.3044 3.29289 12.3041C3.29344 12.3039 3.29477 12.3035 3.29653 12.3035C3.2983 12.3035 3.29962 12.3039 3.30018 12.3041C3.30035 12.3042 3.30039 12.3042 3.30031 12.3042C3.30006 12.304 3.29875 12.3033 3.29653 12.3013ZM11.2915 9.14349V9.42811L11.5363 9.57342L14.4143 11.2822C14.4145 11.2824 14.4147 11.2825 14.415 11.2826C14.5278 11.3508 14.5716 11.5048 14.5012 11.6288C14.4321 11.7407 14.2782 11.7835 14.1546 11.7122C14.1542 11.712 14.1538 11.7118 14.1533 11.7115L11.311 9.98847C11.301 9.98249 11.2916 9.96427 11.2916 9.94775V9.50348V9.14349Z"
            fill="white"
            stroke="black"
        />
    </svg>
);

//------ Playlist Icon ------//
export const PlaylistIcon = ({ width = '1.25vw' }) => (
    <svg width={width} height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Group">
        <path 
          id="Vector" 
          d="M8 15V9L13 12L8 15ZM15 0H5V1H15V0ZM18 3H2V4H18V3ZM20 6H0V18H20V6ZM1 7H19V17H1V7Z" 
          fill="black"
        />
      </g>
    </svg>
  );

//------ Share Icon ------//
export const ShareIcon = ({ width = '1.25vw' }) => (
    <svg width={width} height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        id="Vector" 
        d="M21.16 18.28V20.2L19.72 21.64M25.96 1L1 12.52L12.52 14.92M25.96 1L12.52 14.92M25.96 1L21.76 11.92M12.52 14.92L13.12 17.68M25.96 20.2C25.96 21.473 25.4543 22.6939 24.5541 23.5941C23.6539 24.4943 22.433 25 21.16 25C19.887 25 18.6661 24.4943 17.7659 23.5941C16.8657 22.6939 16.36 21.473 16.36 20.2C16.36 18.927 16.8657 17.7061 17.7659 16.8059C18.6661 15.9057 19.887 15.4 21.16 15.4C22.433 15.4 23.6539 15.9057 24.5541 16.8059C25.4543 17.7061 25.96 18.927 25.96 20.2Z" 
        stroke="black" 
        strokeWidth="1.92" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
      />
    </svg>
  );

//------ Options Icon ------//
export const OptionsIcon = ({ width = '1.25vw' }) => (
    <svg width={width} height="24" viewBox="0 0 33 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        id="Vector" 
        d="M24.8571 13.7143V14.5714H25.7143H31.7143V16.2857H25.7143H24.8571V17.1429V23.1429H23.1429V17.1429V16.2857H22.2857H16.2857V14.5714H22.2857H23.1429V13.7143V7.71429H24.8571V13.7143ZM0.857143 9.42857V7.71429H18V9.42857H0.857143ZM0.857143 2.57143V0.857143H18V2.57143H0.857143ZM11.1429 14.5714V16.2857H0.857143V14.5714H11.1429Z" 
        fill="white" 
        stroke="black" 
        strokeWidth="1.71429" 
      />
    </svg>
  );

  //------ ThumbsUp Icon ------///
  export const ThunmbsUpIcon =({ width= '1.25vw', height= '1.25vw'}) => (
    <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="thumb_up">
      <path
        id="Vector 398"
        d="M8.85 19H6C5.44772 19 5 18.5523 5 18V12C5 11.4477 5.44772 11 6 11H8.85C8.93284 11 9 11.0672 9 11.15V18.85C9 18.9328 8.93284 19 8.85 19Z"
        stroke="#33363F"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        id="Vector 399"
        d="M9 11L10.8321 8.25192C10.9416 8.08766 11 7.89465 11 7.69722V5C11 4.44772 11.4477 4 12 4H13C14.1046 4 15 4.89543 15 6V11"
        stroke="#33363F"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        id="Vector 400"
        d="M13 11H17.7655C18.9575 11 19.8849 12.0361 19.7532 13.2209L19.1977 18.2209C19.0851 19.2337 18.229 20 17.2099 20H13.4142C13.149 20 12.8946 19.8946 12.7071 19.7071L12.2929 19.2929C12.1054 19.1054 11.851 19 11.5858 19H9"
        stroke="#33363F"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
  );

  //------ ThumbsDown Icon ------///
  export const ThumbsDownIcon = ({ width = '1.25vw', height = '1.25vw' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="thumb_down">
        <path
          id="Vector 398"
          d="M8.85 5H6C5.44772 5 5 5.44771 5 6V12C5 12.5523 5.44772 13 6 13H8.85C8.93284 13 9 12.9328 9 12.85V5.15C9 5.06716 8.93284 5 8.85 5Z"
          stroke="#33363F"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          id="Vector 399"
          d="M9 13L10.8321 15.7481C10.9416 15.9123 11 16.1054 11 16.3028V19C11 19.5523 11.4477 20 12 20H13C14.1046 20 15 19.1046 15 18V13"
          stroke="#33363F"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          id="Vector 400"
          d="M13 13H17.7655C18.9575 13 19.8849 11.9639 19.7532 10.7791L19.1977 5.77914C19.0851 4.76627 18.229 4 17.2099 4H13.4142C13.149 4 12.8946 4.10536 12.7071 4.29289L12.2929 4.70711C12.1054 4.89464 11.851 5 11.5858 5H9"
          stroke="#33363F"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );

  //------ BookMark Icon ------//
  export const BookMarkIcon = ({ width = '1.25vw', height = '1.25vw' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Bookmark_fill">
        <path
          id="Rectangle 1"
          d="M3.16699 9C3.16699 6.17157 3.16699 4.75736 3.86261 3.87868C4.55823 3 5.67782 3 7.91699 3H11.0837C13.3228 3 14.4424 3 15.138 3.87868C15.8337 4.75736 15.8337 6.17157 15.8337 9V15.8276C15.8337 18.5109 15.8337 19.8525 15.1653 20.2629C14.4969 20.6733 13.6617 19.8444 11.9913 18.1866L11.4568 17.656C10.5175 16.7239 10.0479 16.2578 9.50033 16.2578C8.95271 16.2578 8.4831 16.7239 7.54389 17.656L7.00932 18.1866C5.33897 19.8444 4.50379 20.6733 3.83539 20.2629C3.16699 19.8525 3.16699 18.5109 3.16699 15.8276V9Z"
          fill="#222222"
          stroke="#222222"
          strokeWidth="2"
        />
      </g>
    </svg>
  );